import { useEffect, useState } from "react";
import { postAxios } from "../../../util/postAxios";

export const useNewsLetter = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;

  const getTim = localStorage.getItem("user");
  const dataUser = JSON.parse(getTim);

  const [isType, setIsType] = useState("");
  const [listOperator, setListOperator] = useState();
  const [operatorPick, setOperatorPick] = useState();
  const [isRefresh, setIsRefresh] = useState(false);

  const [inputS, setInputS] = useState();
  const [inputI, setInputI] = useState();
  const [inputA, setInputA] = useState();

  const [title, setTitle] = useState();
  const [subTitle, setSubTitle] = useState();

  const [tglTerlambat, setTglTerlambat] = useState();

  const [until, setUntil] = useState();

  const [listNewsLetter, setListNewsLetter] = useState();

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/formLembur`,
      { tim: dataUser.tim, type: "getUser" },
      getToken,
      setListOperator,
      ""
    );
  }, []);

  useEffect(() => {
    setOperatorPick();
    setInputS();
    setInputI();
    setInputA();
  }, [isType]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/listNewsLetter`,
      { tim: dataUser.tim },
      getToken,
      setListNewsLetter,
      ""
    );
    setIsRefresh(false);
  }, [isRefresh]);

  let reFormat = [];

  listOperator &&
    listOperator.forEach((element) => {
      reFormat.push({
        value: element.id,
        label: element.name,
      });
    });

  const handleKirimNewsLetter = (type) => {
    if (
      (type === "Berita" && until && title && subTitle) ||
      (type === "Keterlambatan" && until && title && operatorPick) ||
      (type === "SIA" && until && title && (inputS || inputI || inputA))
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewNewsLetter`,
        {
          tim: dataUser.tim,
          type: type,
          operator: operatorPick,
          inputS: Number(inputS),
          inputI: Number(inputI),
          inputA: Number(inputA),
          title: title,
          subTitle: subTitle,
          tglTerlambat: tglTerlambat,
          until: until,
        },
        getToken,
        "",
        ""
      );

      setSubTitle();
      setOperatorPick();
      setTglTerlambat();
      setInputS();
      setInputI();
      setInputA();
      setIsError(false);
      setIsRefresh(true);
    } else {
      setIsError(true);
    }
  };

  const handleChangeEdit = (data, index) => {
    let berita = [...(listNewsLetter && listNewsLetter.berita)];
    let keterlambatan = [...(listNewsLetter && listNewsLetter.keterlambatan)];
    let sia = [...(listNewsLetter && listNewsLetter.sia)];

    if (data.type === "Berita") {
      berita[index][`isEdit`] = true;
    } else if (data.type === "Keterlambatan") {
      keterlambatan[index][`isEdit`] = true;
    } else if (data.type === "SIA") {
      sia[index][`isEdit`] = true;
    }
    setListNewsLetter({
      berita: berita,
      keterlambatan: keterlambatan,
      sia: sia,
    });
  };

  const handleFormChange = (data, index, event, list, i) => {
    let berita = [...(listNewsLetter && listNewsLetter.berita)];
    let keterlambatan = [...(listNewsLetter && listNewsLetter.keterlambatan)];
    let sia = [...(listNewsLetter && listNewsLetter.sia)];

    if (data.type === "Berita") {
      berita[index][event.target.name] = event.target.value;
    } else if (data.type === "Keterlambatan") {
      if (list) {
        keterlambatan[index].list[i][event.target.name] = event.target.value;
      }
      keterlambatan[index][event.target.name] = event.target.value;
    } else if (data.type === "SIA") {
      if (list) {
        sia[index].list[i][event.target.name] = Number(event.target.value);
      } else {
        sia[index][event.target.name] = event.target.value;
      }
    }

    setListNewsLetter({
      berita: berita,
      keterlambatan: keterlambatan,
      sia: sia,
    });
  };

  const handleDelete = (data, index) => {
    let berita = [...(listNewsLetter && listNewsLetter.berita)];
    let keterlambatan = [...(listNewsLetter && listNewsLetter.keterlambatan)];
    let sia = [...(listNewsLetter && listNewsLetter.sia)];

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/editNewsLetter`,
      { tim: dataUser.tim, type: "delete", data: data },
      getToken,
      "",
      ""
    );

    if (data.type === "Berita") {
      berita.splice(index, 1);
    } else if (data.type === "Keterlambatan") {
      keterlambatan.splice(index, 1);
    } else if (data.type === "SIA") {
      sia.splice(index, 1);
    }
    setListNewsLetter({
      berita: berita,
      keterlambatan: keterlambatan,
      sia: sia,
    });
  };

  const handleKirim = (data, index) => {
    let berita = [...(listNewsLetter && listNewsLetter.berita)];
    let keterlambatan = [...(listNewsLetter && listNewsLetter.keterlambatan)];
    let sia = [...(listNewsLetter && listNewsLetter.sia)];

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/editNewsLetter`,
      { tim: dataUser.tim, type: "edit", data: data },
      getToken,
      "",
      ""
    );

    if (data.type === "Berita") {
      berita[index][`isEdit`] = false;
    } else if (data.type === "Keterlambatan") {
      keterlambatan[index][`isEdit`] = false;
    } else if (data.type === "SIA") {
      sia[index][`isEdit`] = false;
    }
    setListNewsLetter({
      berita: berita,
      keterlambatan: keterlambatan,
      sia: sia,
    });
  };

  return {
    isType,
    setIsType,
    reFormat,
    operatorPick,
    setOperatorPick,

    inputS,
    setInputS,
    inputI,
    setInputI,
    inputA,
    setInputA,
    dataUser,
    handleKirimNewsLetter,
    title,
    setTitle,
    subTitle,
    setSubTitle,
    tglTerlambat,
    setTglTerlambat,
    until,
    setUntil,
    listNewsLetter,
    isError,
    setIsRefresh,
    handleChangeEdit,
    handleFormChange,
    handleKirim,
    handleDelete,
  };
};
